export default "__VITE_ASSET__97d9e767__"